import React, { useEffect, useState } from 'react';
import { makeStyles, tokens } from '@fluentui/react-components';
import { useUser } from '@auth/AuthContext';
import { getUserConfigByUserId } from '../../tab/api';
import {
  WelcomeSection,
  CoachingSessionSection,
  AskGroovSection,
  AdditionalSupportSection,
} from './sections';
import { GroovCard } from '@components/groovCard';
import { IntegrationData } from './types';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
    padding: tokens.spacingVerticalL,
    maxWidth: '900px',
    margin: '0 auto',
  },
  cardBody: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalS,
  },
});

 

export const Home: React.FC = () => {
  const styles = useStyles();
  const { groovUser } = useUser();
  const [integrationData, setIntegrationData] = useState<IntegrationData | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchIntegrationData = async () => {
      if (!groovUser?.id) {
        return;
      }

      try {
        const data = await getUserConfigByUserId(groovUser.id);
        setIntegrationData(data);
      } catch (error: unknown) {
        const errorMessage = error instanceof Error ? error.message : 'Unknown error';
        console.error('Failed to fetch integration data:', errorMessage, error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchIntegrationData();
  }, [groovUser?.id]);

  if (isLoading) {
    return null;
  }

  const { privacyPolicyUrl, coachingUrl, isAiEnable, additionalSupport } = integrationData || {};

  return (
    <div className={styles.container}>
      <GroovCard width="100%">
        <div className={styles.cardBody}>
          <WelcomeSection privacyPolicyUrl={privacyPolicyUrl} />
          {coachingUrl && (
            <CoachingSessionSection coachingUrl={coachingUrl} />
          )}
          {isAiEnable === true && (
            <AskGroovSection privacyPolicyUrl={privacyPolicyUrl} />
          )}
          {additionalSupport && (
            <AdditionalSupportSection config={additionalSupport} />
          )}
        </div>
      </GroovCard>
    </div>
  );
};
